import React from "react";
import { CreateNFeContext } from "../../../Context";
import { _Input } from "../../../../../../../_components/Input";
import Modal from "../../../../../../../_components/Modal";
import Text from "../../../../../../../_components/Text";
import LoadingInput from "../../../../../../../_components/LoadingInput";
import IconButton from "../../../../../../../_components/IconButton";
import styled from "styled-components";

import { useSetFinNFe } from "../FinNFe/hooks";

const Div = styled.div`
  display: flex;
  min-width: 100%;
  flex-direction: row;
  align-items: center;
  alig-self: center;

  input {
    min-width: 300px;
    margin-top: 10px;
  }

  i {
    margin-left: 10px;
    margin-bottom: 20px !important;
  }
`;

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  const [other, setOther] = React.useState("");
  const [show, setShow] = React.useState(false);
  const setFinNFe = useSetFinNFe();
  function onChange(e) {
    if (e.target.value === "other") {
      setShow(true);
      setTimeout(() => {
        try {
          document.getElementById("nfe-issuer-input-other-nat-op").focus();
        } catch (error) {}
      }, 500);
    } else {
      const { nfe } = context;
      nfe.identification.nat_op = e.target.value;
      context.handlers.updateNFeData(nfe);
      onSetNatOp(e.target.value);
    }
  }
  function onSave() {
    const { nfe } = context;
    if (other.length > 0) {
      const natOp = other.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

      const filteredList = nfe.identification.nat_op_list.filter(
        (item) => item.toLowerCase() === other.toLowerCase()
      );

      if (filteredList.length) {
        nfe.identification.nat_op = filteredList[0];
      } else {
        nfe.identification.nat_op_list.push(natOp);
        nfe.identification.nat_op = natOp;
      }
    } else {
      nfe.identification.nat_op = "Venda";
    }
    context.handlers.updateNFeData(nfe);
    onSetNatOp(nfe.identification.nat_op);
    onCloseModal();
  }
  function onCloseModal() {
    setOther("");
    setShow(false);
  }
  function onSetNatOp(natOp) {
    natOp = natOp
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    if (natOp.includes("venda")) {
      setFinNFe({ value: "1" });
    }
    if (natOp.includes("devolucao") ) {
      setFinNFe({ value: "4" });
    }
    context.nfe.allow_payments =
      natOp.includes("remessa") || natOp.includes("devolucao");
  }

  return (
    <div>
      <_Input
        label="* Natureza da Operação"
        value={context.nfe.identification.nat_op}
        options={[
          ...context.nfe.identification.nat_op_list.map((op) => {
            return {
              label: op,
              value: op,
            };
          }),
          {
            label: "Outro",
            value: "other",
          },
        ]}
        type="select"
        onChange={(e) => onChange({ target: { value: e.value } })}
      />
      <Modal
        title="Informar natureza da operação"
        show={show}
        onHide={onCloseModal}
      >
        <div>
          <Text color="primary">
            Especifique abaixo a natureza da operação (ex: Remessa de devolução
            para conserto)
          </Text>
          <Div>
            <LoadingInput
              value={other}
              autoFocus
              id="nfe-issuer-input-other-nat-op"
              onChange={(e) => setOther(e.target.value)}
            />
            <IconButton icon="check" onClick={onSave} />
          </Div>
        </div>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/NatOp/index.jsx